import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import UserTable from '../../../components/tables/UserTable';

const generateSampleData = (count = 75) => {
  const statuses = ['Active', 'Inactive'];
  const cities = [
    'Mumbai',
    'Delhi',
    'Bangalore',
    'Hyderabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Ahmedabad',
    'Jaipur',
    'Surat'
  ];

  return Array.from({ length: count }, (_, index) => {
    const joinDate = new Date(
      2021 + Math.floor(Math.random() * 4),
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1
    )
      .toISOString()
      .split('T')[0];

    return {
      id: `RET${String(index + 1).padStart(4, '0')}`,
      limit: Math.floor(Math.random() * 40000) + 10000,
      name: `Retailer ${index + 1}`,
      email: `retailer${index + 1}@network.com`,
      phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      city: cities[Math.floor(Math.random() * cities.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      joinDate
    };
  });
};

const formatCurrency = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return '-';
  }
  return `₹${amount.toLocaleString('en-IN')}`;
};

const UserManagementRetailer = () => {
  const [retailerData, setRetailerData] = useState(() => generateSampleData());

  const handleDataChange = (updatedData) => {
    setRetailerData(
      updatedData.map((item) => ({
        ...item,
        limit:
          item.limit !== undefined && item.limit !== null
            ? item.limit
            : Math.floor(Math.random() * 40000) + 10000,
      }))
    );
  };

  return (
    <Container fluid>
      <UserTable
        data={retailerData}
        userRole="Retailer"
        onDataChange={handleDataChange}
        extraColumns={[
          {
            key: 'limit',
            label: 'Limit (₹)',
            render: (row, value) => formatCurrency(value),
          },
        ]}
      />
    </Container>
  );
};

export default UserManagementRetailer;

